// import { useCallback, useContext, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ModalWrapper } from './modal_wrapper'
import { Link } from 'react-router-dom'
import { Unit } from '../types'

type Props = Readonly<{
  onClose: () => void
  unit?: Unit
}>

const UnitBuyCompleteModal = ({ onClose, unit: _unit }: Props) => {
  // const { addError } = useContext(ErrorsContext)
  // const { currentUser } = useContext(AuthContext)

  // const [loading, setLoading] = useState<boolean>(false)
  // const [inCollection, setInCollection] = useState<boolean>(false)

  // const addToCollection = useCallback(() => {
  //   if (loading || !unit || !unit.items) return

  //   setLoading(true)

  //   // add a new user item
  //   unitsRepository
  //     .create({
  //       itemIds: unit.items.map((item) => item.id),
  //       condition: unit.condition,
  //     })
  //     .then(() => {
  //       setInCollection(true)
  //     })
  //     .catch((err: AxiosError) => {
  //       addError?.(err)
  //     })
  //     .finally(() => {
  //       setLoading(false)
  //     })
  // }, [loading, unit, addError])

  const { t } = useTranslation()

  return (
    <ModalWrapper>
      <div>
        <h1>{ t('checkout.complete.title') }</h1>
        <p>
          { t('checkout.complete.confirmed') }
        </p>
        <p>
          { t('checkout.complete.shipped_email') }
        </p>
        <p>
          <Trans
            i18nKey="checkout.complete.prepaid"
            components={ { bold: <strong /> } }
          />
        </p>
        <p>
          { t('checkout.complete.thanks') }
        </p>
        {
          // unit && currentUser
          //   ? inCollection
          //     ? <><p><strong>マイデッキに追加されました！</strong></p><p><Link to={ `/u/${currentUser.id}` } className="button full">マイデッキを見る</Link></p></>
          //     : <p><button className="full white" onClick={ addToCollection } disabled={ loading }>マイデッキに移動する</button></p>
          //   : null
        }
        <p>
          <Link to="/orders/latest" className="button full white" onClick={ onClose }>
            { t('checkout.complete.view_order') }
          </Link>
        </p>
        <p>
          <button className="full" onClick={ onClose }>
            { t('checkout.complete.close') }
          </button>
        </p>
      </div>
    </ModalWrapper>
  )
}

export { UnitBuyCompleteModal }
